import UserLoggedService from '@services/resources/UserLoggedService';
import UserFlagsService from '@services/resources/UserFlagsService'

const service = UserLoggedService.build();
const userFlagsService = UserFlagsService.build();

import router from '@router/index'

export default {
    userRequest: ({ commit, dispatch }) => {


        service.get('')
            .then((resp) => {
                commit('userSuccess', resp);
                dispatch('redirectUserToHome')
                dispatch('fetchUserFlags').catch((err) => {
                    console.error('Failed to fetch user flags:', err);
                });
            })
            .catch((err) => {
                //commit('userError');
                // if resp is unauthorized, logout, to
               // dispatch('authLogout')
                console.error("Erro no fluxo de usuário:", err);
            });



    },
    redirectUserToHome: (context) => {

        router.push('/');

    },

    fetchUserFlags: async ({ commit, getters }) => {
        const userId = getters.getProfile.id;

        try {
            const flags = await userFlagsService.read({ id: userId });

            commit('setUserFlags', flags)
        } catch (error) {
            console.error(`Failed to fetch flags for user ${userId}:`, error);

            throw error;
        }
    }
}
